var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("basic-container", [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("screen-form", {
          attrs: {
            title: "老系统线路名称",
            startAreaList: _vm.startAreaList,
            oldLine: _vm.oldLine,
            endAreaList: _vm.endAreaList,
          },
          on: { search: _vm.onSearch, add: _vm.onAdd, reset: _vm.onReset },
        }),
        _c("line-table", {
          attrs: { records: _vm.records, total: _vm.paginationTotal },
          on: { current: _vm.onPaginationCurrent, delete: _vm.onDelete },
        }),
        _c("line-edit-modal", {
          attrs: {
            title: "新增",
            visible: _vm.dialogFormVisible,
            areaList: _vm.startAreaList,
            oldLine: _vm.oldLine,
          },
          on: { save: _vm.saveLineConfig },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }